module.exports = __webpack_public_path__ + "img/pic_recruit_picture1.f09ad6bf.png";